import React from 'react';
import classnames from 'classnames';
import Button, { LoadingButton } from '@atlaskit/button';

import './dark-button.scss';

export const DarkButton = (props: React.ComponentProps<typeof Button>) => {
  return <Button {...props} className={classnames('ppc-dark-btn', props.className)} />;
};

export const DarkLoadingButton = (props: React.ComponentProps<typeof LoadingButton>) => {
  return <LoadingButton {...props} className={classnames('ppc-dark-btn', props.className)} />;
};
